import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHackerrankComponent } from './simple-icons-hackerrank.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHackerrankComponent ],
    exports:      [ SimpleIconsHackerrankComponent ],
    bootstrap:    []
})
export class SimpleIconsHackerrankModule {}
